$(".data_midia").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: ".data_midia_2",
  prevArrow: $(".custom-prev-arrow"),
  nextArrow: $(".custom-next-arrow"),
});

$(".data_midia_2").slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: ".data_midia",
  dots: false,
  centerMode: false,
  arrows: false,
  focusOnSelect: true,
});

// $('.nav-coll .nav-item-coll').click(function(){
//     $(this).parents('.nav-coll').toggleClass('open_arrow');
//     $(this).parents('.nav-coll').siblings().removeClass('open_arrow');
// });
$('.nav-coll .all-links a.main-links-all').click(function(){
    var name = $(this).attr('attr_title'); 
    localStorage.setItem('collections_name', name);
});
 $(document).ready(function () {
var currentUrl = window.location.pathname;
    if (currentUrl.includes('/collections')) {
        var collectionValue = currentUrl.split('/')[2]; 
         localStorage.setItem('collections_name', collectionValue);
         localStorage.setItem('main_collections', collectionValue);
    }
  setTimeout(function() {
   var data = localStorage.getItem('collections_name');
    var data1 = localStorage.getItem('main_collections');
  $(".main-nav-div .nav-coll").each(function(index) {
    var names = $(this).attr('attr-ports'); 
    if (data1 == names) {
      $(this).addClass('show_collection')
    }
    $(this).find('.all-links').find('a.main-links-all').each(function() {
        var name = $(this).attr('attr_title'); 
        var links = $(this).attr('attr_links'); 
        if (data == name || data == links) {
          $(this).addClass('open_arrow')
           $(this).parents('.nav-coll').addClass('show_collection')
        }
    });
  });
       }, 1000);
 });

// $(document).ready(function () {
//   var data_ck = true;

//   $(".make_coll li.grid__item").each(function (index) {
//     var attr = $(this).attr("atrr_coll");
//     if (attr !== "") {
//       data_ck = false;
//       return false;
//     }
//   });

//   if (data_ck) {
//     $(".serach_not_find").show();
//   }
// });

$(".main_head_coll ul.list-menu.list-menu--inline li").hover(function () {
  var isHovered = $(this).is(":hover");
  if (isHovered) {
    $(this).find("details-disclosure").children("details").attr("open", "open");
    var title = $(this)
      .find("details-disclosure")
      .children("details")
      .attr("attr_ck");
    console.log(title);
    $(this)
      .find("details-disclosure")
      .children("details")
      .find(".last_main_coll")
      .children(".main_content")
      .find("a.main_link_ds")
      .each(function (index) {
        var attr = $(this).attr("main_check");
        if (title == attr) {
          $(this).addClass("show_image");
        } else {
          $(this).removeClass("show_image");
        }
      });
  } else {
    $(this).find("details-disclosure").children("details").removeAttr("open");
    $(this)
      .find("details-disclosure")
      .children("details")
      .find(".last_main_coll")
      .children(".main_content")
      .find("a.main_link_ds")
      .each(function (index) {
        var attr = $(this).attr("main_check");
        if (title == attr) {
          $(this).addClass("show_image");
        } else {
          $(this).removeClass("show_image");
        }
      });
  }
});
